export const messages = {
  en: {
    operateDataLog: {
      search: {
        title: 'Search Conditions',
        logStartTime: 'Please select the start time',
        logEndTime: 'Please select the end time',
        staffNameLike: 'Please enter the operator',
        feeNameLike: 'Please enter the fee item name',
        payerObjName: 'Please enter the house name, license plate number or contract number',
        ownerNameLike: 'Please enter the owner name',
        roomName: 'Please enter the house name  Building-Unit-Room',
        carNumLike: 'Please enter the license plate number',
        contractCode: 'Please enter the contract number'
      },
    },
    feeConfigDetailHis: {
      feeTypeCdName: 'fee type',
      feeName: 'fee item',
      feeFlagName: 'fee flag',
      billTypeName: 'bill type',
      paymentCd: 'payment type',
      prePayment: 'pre payment',
      postPayment: 'post payment',
      paymentCycle: 'payment cycle(unit: month)',
      validityPeriod: 'validity period',
      squarePrice: 'square price(unit: yuan)',
      additionalAmount: 'additional/fixed fee(unit: yuan)',
      deductFrom: 'deduct from',
      payOnline: 'pay online',
      scale: 'scale',
      round: 'round',
      roundUp: 'round up',
      roundDown: 'round down',
      decimalPlace: 'decimal place',
      operate: 'action',
      userName: 'operator',
        createTime: 'create time',
      add: 'add',
      delete: 'delete',
      modifyNew: 'modify(new)',
      modifyOld: 'modify(old)'
    },
    feeDetailHis: {
      feeName: 'fee item',
      startTime: 'create time',
      endTime: 'start time',
      operate: 'action',
      userName: 'operator',
      createTime: 'create time',
      add: 'add',
      delete: 'delete',
      modifyNew: 'modify(new)',
      modifyOld: 'modify(old)'
    },
    roomDetailHis: {
      operate: 'action',
      userName: 'operator',
      createTime: 'create time',
      roomNum: 'room number',
      layer: 'layer',
      roomSubTypeName: 'type',
      area: 'area',
      roomRent: 'rent',
        stateName: 'state',
      add: 'add',
      delete: 'delete',
      modifyNew: 'modify(new)',
      modifyOld: 'modify(old)'
    },
   
   
  },
  zh: {
    operateDataLog: {
      search: {
        title: '查询条件',
        logStartTime: '请选择开始时间',
        logEndTime: '请选择结束时间',
        staffNameLike: '请输入操作人',
        feeNameLike: '请输入费用项名称',
        payerObjName: '请输入房屋名称，车牌号或者合同编号',
        ownerNameLike: '请输入业主名称',
        roomName: '请输入房屋名称 楼栋-单元-房屋',
        carNumLike: '请输入车牌号',
        contractCode: '请输入合同编号'
      }
    },
    feeConfigDetailHis: {
      feeTypeCdName: '费用类型',
      feeName: '收费项目',
      feeFlagName: '费用标识',
      billTypeName: '催缴类型',
      paymentCd: '付费类型',
      prePayment: '预付费',
      postPayment: '后付费',
      paymentCycle: '缴费周期(单位:月)',
      validityPeriod: '有效期',
      squarePrice: '计费单价(单位:元)',
      additionalAmount: '附加/固定费用(单位:元)',
      deductFrom: '账户抵扣',
      payOnline: '手机缴费',
      scale: '进位方式',
      round: '四舍五入',
      roundUp: '向上进位',
      roundDown: '向下进位',
      decimalPlace: '保留小数',
      operate: '动作',
      userName: '操作人',
      createTime: '操作时间',
      add: '添加',
      delete: '删除',
      modifyNew: '修改(新)',
      modifyOld: '修改(旧)'
    },
    feeDetailHis: {
      feeName: '费用项',
      startTime: '建账时间',
      endTime: '计费起始时间',
      operate: '动作',
      userName: '操作人',
      createTime: '操作时间',
      add: '添加',
      delete: '删除',
      modifyNew: '修改(新)',
      modifyOld: '修改(旧)'
    },
roomDetailHis: {
      operate: '动作',
      userName: '操作人',
      createTime: '操作时间',
      roomNum: '房号',
      layer: '楼层',
      roomSubTypeName: '类型',
      area: '建筑/室内面积',
      roomRent: '租金',
      stateName: '房屋状态',
      add: '添加',
      delete: '删除',
      modifyNew: '修改(新)',
      modifyOld: '修改(旧)'
    },

   
  },
  'zh-TW': {
    operateDataLog: {
      search: {
        title: '查詢條件',
        logStartTime: '請選擇開始時間',
        logEndTime: '請選擇結束時間',
        staffNameLike: '請輸入操作人',
        feeNameLike: '請輸入費用項名稱',
        payerObjName: '請輸入房屋名稱，車牌號或者合同編號',
        ownerNameLike: '請輸入業主名稱',
        roomName: '請輸入房屋名稱 樓棟-單元-房屋',
        carNumLike: '請輸入車牌號',
        contractCode: '請輸入合同編號'
      }
    },
    feeConfigDetailHis: {
      feeTypeCdName: '費用類型',
      feeName: '收費項目',
      feeFlagName: '費用標識',
      billTypeName: '催繳類型',
      paymentCd: '付費類型',
      prePayment: '預付費',
      postPayment: '後付費',
      paymentCycle: '繳費週期(單位:月)',
      validityPeriod: '有效期',
      squarePrice: '計費單價(單位:元)',
      additionalAmount: '附加/固定費用(單位:元)',
      deductFrom: '帳戶抵扣',
      payOnline: '手機繳費',
      scale: '進位方式',
      round: '四捨五入',
      roundUp: '向上進位',
      roundDown: '向下進位',
      decimalPlace: '保留小數',
      operate: '動作',
      userName: '操作人',
      createTime: '操作時間',
      add: '添加',
      delete: '刪除',
      modifyNew: '修改(新)',
      modifyOld: '修改(舊)'
    },
    feeDetailHis: {
      feeName: '費用項',
      startTime: '建帳時間',
      endTime: '計費起始時間',
      operate: '動作',
      userName: '操作人',
      createTime: '操作時間',
      add: '添加',
      delete: '刪除',
      modifyNew: '修改(新)',
      modifyOld: '修改(舊)'
    },
    roomDetailHis: {
      operate: '動作',
      userName: '操作人',
      createTime: '操作時間',
      roomNum: '房號',
      layer: '樓層',
      roomSubTypeName: '類型',
      area: '建築/室內面積',
      roomRent: '租金',
      stateName: '房屋狀態',
      add: '添加',
      delete: '刪除',
      modifyNew: '修改(新)',
      modifyOld: '修改(舊)'
    },

   
  },
}